/*
Copyright (c) 2021, Company copyrght header.
*/

import { all, putResolve, takeEvery, takeLatest } from 'redux-saga/effects';
import actions from '../actions';
import * as authenticateMethods from '../utils/api/login/login';
import * as tagMethods from './tag/tag';
import * as projectMethods from './project/project';
import {
  DELETE_PROJECT_IMAGE,
  DELETE_PROJECT_TASK,
  PRE_PROJECT_DATA,
  EDIT_PROJECT_TASK,
  CREATE_PROJECT_LEAD,
  ADD_PROJECT_RESEARCHER,
  ADD_PROJECT_OBSERVER,
  GET_CRITERIA_AND_BUDGET,
  UPDATE_STAGE,
  GET_RESOLUTION,
  GET_PARTICIPANTS_LIST,
  SEND_PARTICIPANTS_LIST_ONEND,
  REMOVE_VIDEO_CALL,
  ADD_NEW_PROJECT_TASK,
  EDIT_SECTION,
  ADD_SECTION,
  DRAG_QUESTION,
  COUNT_NO_OF_PARTICIPANTS,
  VIDEO_RECORDING,
  VIDEO_RECORDING_RESOURCE,
  QUERY_VIDEO_RECORDING,
  UPDATELAYOUT_VIDEO_RECORDING,
  STOP_VIDEO_RECORDING,
  RESUME_DATA,
  SCHEDULE_CALL,
  UPDATE_DURATION,
  VIDEO_USERLIST,
  REQUEST_GETUIDDETAILS,
  VIDEO_RECORDING_UPDATE,
  RTC_TOKEN_BUILDER,
  DELETE_TEAM_MEMBER,
  SAVE_RTM_TRANSCRIPT_DATA,
  STORE_RTM_TRANSCRIPT_LOGS,
  GET_RTM_TRANSCRIPT_DATA,
  GET_CHAPTERIZATION_DATA,
  UPDATE_RTM_TRANSCRIPT_DATA,
  UPDATE_GUEST_DATA,
  UPDATE_SID_DATA,
  DRAG_QUESTION_ACROSS_SECTIONS,
  DRAG_SECTION
} from '../constants/projects/ProjectConstants';
import {
  getProjectPreData,
  deleteProjectImage,
  deleteProjectTask,
  updateProjectTask,
  createProjectLead,
  addProjectResearchers,
  addProjectObservers,
  getCriteriaAndBudgets,
  updateStage,
  getResolutions,
  getParticipants,
  SendParticpantsListOnEnd,
  removeVideoCalls,
  GetEditSections,
  GetAddSections,
  GetDragQuestions,
  GetDragQuestionAcrossSections,
  CountNoParticipants,
  EditScreenerAnswers,
  VideoRecordings,
  VideoRecordingResources,
  QueryVideoRecordings,
  updateLayoutVideoRecordings,
  stopVideoRecordings,
  ResumeData,
  SchedulecallData,
  updateDurations,
  addNewProjectTask,
  VideoRecordingUserLists,
  getUIDDetailss,
  VideoRecordingUpdates,
  RtcTokenBuilders,
  deleteTeamMember,
  saveRtmTranscriptDatas,
  storeTranscriptLog,
  getRtmTranscriptDatas,
  getChapterizationDatas,
  REQUEST_DELETEFORMTAG,
  DELETEFORMTAG_RECEIVED,
  updateRtmTranscriptDatas,
  updateGuestDatas,
  editAutomatedScreener
} from './project/project';
import * as projectsetdataMethods from './invite-recruit/projectsetdatasaga';
import * as updateProjectTaskStatusMethods from './invite-recruit/UpdateProjectTaskStatusSaga';
import * as RecruitsGroupMethods from './invite-recruit/RecruitsGroupsaga';
import * as SendInviteMethods from './invite-recruit/SendInvitesaga';
import * as AddVideoTagMethods from './field/AddVideoTagsaga';
import * as AddVideoNoteMethods from './field/AddVideoNotesaga';
import * as AddVideoTrimMethods from './field/AddVideoTrimSaga';
import * as GetAllTrimClipsMethods from './field/GetAllTrimClipsSaga';
import * as GetVideoTagMethods from './field/GetVideoTagsaga';
import * as GetVideoNoteMethods from './field/GetVideoNotesaga';
import * as GetVideoMethods from './field/GetVideoSaga';
import * as RecruitScreenerMethods from './invite-recruit/RecruitScreenerSaga';
import * as SendRejectMethods from './invite-recruit/SendRejectSaga';
import * as GetInviteeMethods from './invite-recruit/GetInviteesaga';
import * as ConfirmAndAssignMethods from './invite-recruit/ConfirmAndAssignSaga';
import * as ReassignProjectGroupsMethods from './invite-recruit/ReassignProjectGroupsSaga';
import * as ConfirmRespondentMethods from './invite-recruit/ConfirmRespondentSaga';
import * as GetFieldTaskMethods from './field/GetFieldTaskSaga';
import * as GetTaskStatusMethods from './field/GetTaskStatusSaga';
import * as GetVideoTaskStatusMethods from './field/GetVideoTaskStatusSaga';
import * as GetTaskMethods from './field/GetTaskSaga';
import * as getTaskProject from './design/design';
import * as GetPublishMethods from './publish/PublishSaga';
import * as webDashboardMethods from './dashboard/webDashboardsaga';
import * as GetFieldMethods from './field/GetFieldOverviewSaga';
import * as GetCaptureGuideMethods from './field/GetCaptureGuideSaga';
import * as AddNewNoteMethods from './field/AddNewNoteSaga';
import * as GetRecordedVideoMethods from './field/GetRecordTaskVideoSaga';
import * as AddTimeVideoQuestionsMethods from './field/AddTimeVideoQuestionsSaga';
import * as FieldPreEditorSagaMethods from './field/FieldPreEditorSaga';
import * as StartInterviewMethods from './field/StartInterviewSaga';
import * as EndInterviewMethods from './field/EndInterviewSaga';
import * as DeleteVideoNoteMethods from './field/DeleteVideoNoteSaga';
import * as DeleteVideoTagMethods from './field/DeleteVideoTagSaga';
import * as EditVideoNoteMethods from './field/EditVideoNoteSaga';
import * as EditButtonNameMethods from './field/EditButtonNameSaga';
import * as GetProfileMethods from './profile/GetProfileSaga';
import * as EditProfileMethods from './profile/EditProfileSaga';
import * as logoutMethods from '../utils/api/login/login';
import * as ResetMethods from '../utils/api/reset-password/resetPassword';
import * as analysisMethods from './analysis/analysisDatasaga';
import * as GetPublishProjectMethods from './publish/PublishProjectSaga';
import * as graphMethods from './analysis/graphDataSaga';
import * as DeleteVideoClipMethods from './field/DeleteVideoClipSaga';
import * as ChangePasswordWebMethods from './Security/ChangePasswordWebSaga';
import * as wordMethods from './analysis/wordDataSaga';
import * as EditClipMethods from './field/EditClipSaga';
import * as filterMethods from './analysis/filterDataSaga';
import * as cohortMethods from './analysis/addCohortSaga';
import * as stitchVideo from './analysis/stitchVideoSaga';
import * as AddRescheduleSlotMethods from './field/AddResheduleSlotSaga';
import { deleteProjectImageReceived } from '../actions/project';
import * as endProjectMethods from './dashboard/endProjectSaga';
import * as AddRespondentAnswerMethods from './field/AddRespondentAnswerSaga';
import * as clientDashboardMethods from './clientAdmin/clientDashboardsaga';
import * as EditTeamMethods from './clientAdmin/EditTeamDataSaga';
import * as AddNewUserMethods from './clientAdmin/AddNewUserSaga';
import * as EditUserMethods from './clientAdmin/EditUserDataSaga';
import * as AddNewClientAdminMethods from './superAdmin/AddNewClientAdminSaga';
import * as SuperAdminDashboardMethods from './superAdmin/SuperAdminDashboardSaga';
import * as EditClientAdminMethods from './superAdmin/EditClientAdminSaga';
import * as viewUserInGeneralpoolMethods from './superAdmin/ViewUserInGeneralPoolSaga';
import * as AddnewUserGenPoolMethods from './superAdmin/AddNewUserGenPoolSaga';
import * as EditResearcherGenPoolMethods from './superAdmin/EditResearcherDataGenPoolSaga';
import * as EditRespondantGenPoolMethods from './superAdmin/EditRespondantDataGenPoolSaga';
import * as ViewProjectSuperAdminDashboardMethods from './superAdmin/ViewProjectSuperAdminDashboardSaga';
import * as DeleteProjectMethods from './clientAdmin/DeleteProjectSaga';
import * as UpdatePasswordMethods from './superAdmin/UpdatePasswordSaga';
import * as PasswordResetEmailNotificatinValidateTokenMethods from './superAdmin/ResetPasswordEmailNotificationValidatetokenSaga';
import * as SendOtpMethods from './otp/OtpSaga';
import * as OtpVerificationMethods from './otpVerification/otpVerificationSaga';
import * as AnalysisClipsDataMethods from './analysis/analysisClipsDataSaga';
import * as calendarDataMethods from './dashboard/calenderDataSaga';
import * as checkSummaryMethods from './analysis/checkSummarySaga';
import * as getSummaryMethods from './field/GetSummarySaga';
import * as generateSummaryMethods from './analysis/generateSummarySaga';
import * as updateLayoutMethods from './field/UpdateLayoutSaga';
import * as downloadTranscriptMethods from './analysis/transcriptCsvSaga';

function* loginUser(payload) {
  const promise = authenticateMethods.loginUser(payload.payload);
  const { res } = yield promise;
  yield putResolve({ type: actions.LoginActions.USER_LOGIN_RECEIVED, data: res });
}

function* logoutUser(payload) {
  const promise = logoutMethods.logoutUser(payload.payload);
  const { res } = yield promise;
  yield putResolve({ type: actions.LoginActions.USER_LOGOUT_RECEIVED, data: res.Response });
}

function* ResetPassword(payload) {
  const promise = ResetMethods.ResetPassword(payload.payload);
  const { res } = yield promise;
  yield putResolve({ type: actions.ResetPasswordAction.RESET_PASSWORD, data: res.Response });
}

function* actionWatcher() {
  yield takeLatest(actions.LoginActions.REQUEST_USER_LOGIN, loginUser);
  yield takeLatest(actions.LoginActions.REQUEST_USER_LOGOUT, logoutUser);
  yield takeLatest(actions.ResetPasswordAction.RESET_PASSWORD, ResetPassword);
  yield takeLatest(actions.TagActions.REQUEST_ADD_TAG, tagMethods.addTag);
  yield takeLatest(actions.TagActions.REQUEST_GET_TAGS_LIST, tagMethods.getTags);
  yield takeLatest(actions.QuestionActions.REQUEST_CREATE_PROJECT, projectMethods.createProject);
  yield takeLatest(actions.QuestionActions.REQUEST_EDIT_PROJECT, projectMethods.editProject);
  yield takeLatest(actions.QuestionActions.REQUEST_DELETE_REFERRAL, projectMethods.deleteReferral);
  yield takeLatest(actions.ProjectsetupAction.REQUEST_PROJECTSETUPDATA, projectsetdataMethods.projectsetupdata);
  yield takeLatest(
    actions.ProjectsetupAction.REQUEST_UPDATE_TASK_STATUS,
    updateProjectTaskStatusMethods.requestUpdateTaskStatus
  );
  yield takeLatest(actions.RecruitsGroupAction.REQUEST_RECRUITSGROUPDATA, RecruitsGroupMethods.RecruitsGroupData);
  yield takeLatest(actions.ConfirmAndAssignAction.CONFIRM_AND_ASSIGN, ConfirmAndAssignMethods.ConfirmAndAssignData);
  yield takeLatest(actions.GetInviteeAction.REQUEST_INVITEE_DATA, GetInviteeMethods.GetInviteeData);
  yield takeLatest(actions.SendRejectionAction.REQUEST_SEND_REJECT, SendRejectMethods.SendRejectionData);
  yield takeLatest(actions.SendInviteAction.REQUEST_SENDINVITATION, SendInviteMethods.SendInviteData);
  yield takeLatest(actions.AddVideoTagAction.REQUEST_ADDVIDEOTAG, AddVideoTagMethods.AddVideoTagData);
  yield takeLatest(actions.AddVideoNoteAction.REQUEST_ADDVIDEONOTE, AddVideoNoteMethods.AddVideoNoteData);
  yield takeLatest(actions.AddVideoTrimAction.REQUEST_ADDVIDEOTRIM, AddVideoTrimMethods.AddVideoTrimData);
  yield takeLatest(actions.GetAllTrimClipsAction.REQUEST_ALLTRIMCLIPS, GetAllTrimClipsMethods.GetAllTrimClips);
  yield takeLatest(actions.GetVideoTagAction.REQUEST_GETVIDEOTAG, GetVideoTagMethods.GetVideoTagData);
  yield takeLatest(actions.GetVideoNoteAction.REQUEST_GETVIDEONOTE, GetVideoNoteMethods.GetVideoNoteData);
  yield takeLatest(actions.GetVideoAction.REQUEST_GETVIDEO, GetVideoMethods.GetVideoData);

  yield takeLatest(actions.RecruitScreener.REQUEST_RECRUITS_SCREENER_DATA, RecruitScreenerMethods.RecruitScreenerData);
  yield takeLatest(
    actions.ReassignProjectGroupsAction.REASSIGN_PROJECT_GROUP,
    ReassignProjectGroupsMethods.ReassignProjectGroupsData
  );
  yield takeLatest(actions.ConfirmRespondentAction.CONFIRM_RESPONDENT, ConfirmRespondentMethods.ConfirmRespondentData);

  yield takeLatest(actions.GetFieldTaskAction.GET_FIELD_TASK_COMPLETE_COUNT, GetFieldTaskMethods.GetFieldTaskData);
  yield takeLatest(actions.GetTaskStatusAction.GET_TASK_COMPLETION_STATUS, GetTaskStatusMethods.GetTaskStatusData);
  yield takeLatest(
    actions.GetVideoTaskStatusAction.GET_VIDEO_TASK_COMPLETION_STATUS,
    GetVideoTaskStatusMethods.GetVideoTaskStatusData
  );
  yield takeLatest(actions.GetTaskAction.GET_TASK, GetTaskMethods.GetTaskData);

  yield takeLatest(actions.ProjectActions.REQUEST_ADD_QUESITON, getTaskProject.addQuestion);
  yield takeLatest(actions.ProjectActions.REQUEST_SHOW_ScreenerValidation, getTaskProject.showScreenerFilterOnAnalysis);

  yield takeLatest(actions.ProjectActions.REQUEST_QUESTION_EDIT, getTaskProject.editTaskQuestion);

  yield takeLatest(actions.ProjectActions.REQUEST_UPDATE_PROJECT_SCREENER, getTaskProject.updateProjectScreener);

  yield takeLatest(
    actions.ProjectActions.REQUEST_ADD_SCREENER_VALIDATION_QUESTION,
    getTaskProject.addScreenerValidationQuestion
  );
  yield takeLatest(actions.ProjectActions.REQUEST_EDIT_SCREENER_ANSWER, EditScreenerAnswers);
  yield takeLatest(actions.ProjectActions.REQUEST_EDIT_AUTOMATED_SCREENER, editAutomatedScreener);
  yield takeLatest(actions.ProjectActions.REQUEST_ADD_QUESTION_TAGS, getTaskProject.addQuestionTags);
  yield takeLatest(actions.ProjectActions.REQUEST_DELETE_QUESTION_TAG, getTaskProject.deleteQuestionTag);
  yield takeLatest(actions.ProjectActions.REQUEST_DELETEFORMTAG, getTaskProject.DeleteFormTagData);

  yield takeLatest(actions.ProjectActions.REQUEST_VIDEO_QUESTION_EDIT, getTaskProject.editVideoQuestion);

  yield takeLatest(actions.ProjectActions.REQUEST_GET_VIDEO_TASK, getTaskProject.getTaskVideo);
  yield takeLatest(actions.ProjectActions.REQUEST_DELETE_QUESITON, getTaskProject.deleteQuestion);
  yield takeLatest(actions.ProjectActions.REQUEST_DELETE_SECTION, getTaskProject.deleteSection);

  yield takeLatest(PRE_PROJECT_DATA, getProjectPreData);
  yield takeLatest(DELETE_PROJECT_TASK, deleteProjectTask);
  yield takeLatest(DELETE_PROJECT_IMAGE, deleteProjectImage);
  yield takeLatest(EDIT_PROJECT_TASK, updateProjectTask);
  yield takeLatest(CREATE_PROJECT_LEAD, createProjectLead);
  yield takeLatest(ADD_NEW_PROJECT_TASK, addNewProjectTask);
  yield takeLatest(ADD_PROJECT_RESEARCHER, addProjectResearchers);
  yield takeLatest(ADD_PROJECT_OBSERVER, addProjectObservers);
  yield takeLatest(GET_CRITERIA_AND_BUDGET, getCriteriaAndBudgets);
  yield takeLatest(UPDATE_STAGE, updateStage);
  yield takeLatest(GET_RESOLUTION, getResolutions);
  yield takeLatest(GET_PARTICIPANTS_LIST, getParticipants);
  yield takeLatest(SEND_PARTICIPANTS_LIST_ONEND, SendParticpantsListOnEnd);
  yield takeLatest(REMOVE_VIDEO_CALL, removeVideoCalls);

  yield takeLatest(EDIT_SECTION, GetEditSections);
  yield takeLatest(ADD_SECTION, GetAddSections);
  yield takeLatest(DRAG_QUESTION, GetDragQuestions);
  yield takeLatest(DRAG_SECTION, projectMethods.GetDragSections);
  yield takeLatest(DRAG_QUESTION_ACROSS_SECTIONS, GetDragQuestionAcrossSections);
  yield takeLatest(COUNT_NO_OF_PARTICIPANTS, CountNoParticipants);

  yield takeLatest(VIDEO_RECORDING, VideoRecordings);
  yield takeLatest(VIDEO_RECORDING_RESOURCE, VideoRecordingResources);
  yield takeLatest(QUERY_VIDEO_RECORDING, QueryVideoRecordings);
  yield takeLatest(UPDATELAYOUT_VIDEO_RECORDING, updateLayoutVideoRecordings);
  yield takeLatest(STOP_VIDEO_RECORDING, stopVideoRecordings);
  yield takeLatest(RESUME_DATA, ResumeData);
  yield takeLatest(SCHEDULE_CALL, SchedulecallData);

  yield takeLatest(UPDATE_DURATION, updateDurations);

  yield takeLatest(SAVE_RTM_TRANSCRIPT_DATA, saveRtmTranscriptDatas);
  yield takeLatest(UPDATE_SID_DATA, projectMethods.updateSid);
  yield takeLatest(STORE_RTM_TRANSCRIPT_LOGS, storeTranscriptLog);
  yield takeLatest(GET_RTM_TRANSCRIPT_DATA, getRtmTranscriptDatas);
  yield takeLatest(GET_CHAPTERIZATION_DATA, getChapterizationDatas);
  yield takeLatest(UPDATE_RTM_TRANSCRIPT_DATA, updateRtmTranscriptDatas);
  yield takeLatest(UPDATE_GUEST_DATA, updateGuestDatas);

  yield takeLatest(actions.ProjectActions.REQUEST_GET_PROJECT_TASK, getTaskProject.getTaskProject);
  yield takeLatest(actions.ProjectActions.REQUEST_GET_VIDEO_TASK, getTaskProject.getTaskVideo);
  // yield takeLatest(actions.ProjectActions.REQUEST_DELETE_QUESITON, getTaskProject.deleteQuestion);

  yield takeLatest(actions.ProjectActions.REQUEST_SCHEDULE_DATES, projectMethods.getScheduleDate);
  yield takeLatest(actions.ProjectActions.ADD_SCHEDULE_DATE, projectMethods.addScheduleDate);
  yield takeLatest(actions.ProjectActions.EDIT_SCHEDULE_DATE, projectMethods.editScheduleDate);
  yield takeLatest(actions.ProjectActions.DELETE_SCHEDULE_DATE, projectMethods.deleteScheduleDate);
  yield takeLatest(actions.ProjectActions.ADD_PROJECT_GROUP, projectMethods.addProjectGroup);
  yield takeLatest(actions.ProjectActions.EDIT_PROJECT_GROUP, projectMethods.editProjectGroup);
  yield takeLatest(actions.ProjectActions.DELETE_PROJECT_GROUP, projectMethods.deleteProjectGroup);
  yield takeLatest(actions.ProjectActions.CREATE_BUDGET, projectMethods.createBudget);

  yield takeLatest(actions.ProjectActions.ASSIGN_SAMPLE_AND_BUDGET, projectMethods.assignSampleAndBudget);
  yield takeLatest(actions.ProjectActions.DEASSIGN_SAMPLE_AND_BUDGET, projectMethods.deassignSampleAndBudget);

  yield takeLatest(actions.PublishAction.REQUEST_PUBLISH_DATA, GetPublishMethods.GetPublishData);
  yield takeLatest(actions.webDashboardAction.REQUEST_WEBDASHBOARD_DATA, webDashboardMethods.webDashboardData);
  yield takeLatest(actions.calenderDataAction.REQUEST_CALENDER_DATA, calendarDataMethods.calendarData);
  yield takeLatest(actions.GetFieldOverviewAction.REQUEST_FIELD_DATA, GetFieldMethods.GetFieldData);
  yield takeLatest(
    actions.GetRecordTaskVideoAction.GET_RECORD_TASK_VIDEO,
    GetRecordedVideoMethods.GetRecordedVideoData
  );
  yield takeLatest(actions.GetCaptureGuideAction.REQUEST_CAPTURE_GUIDE, GetCaptureGuideMethods.GetCaptureGuideData);
  yield takeLatest(actions.AddNewNoteAction.REQUEST_ADDNEWNOTE, AddNewNoteMethods.AddNewNoteData);
  yield takeLatest(
    actions.AddTimeVideoQuestionsAction.REQUEST_ADDTIMEVIDEOQUESTION,
    AddTimeVideoQuestionsMethods.AddTimeVideoQuestionsData
  );
  yield takeLatest(actions.FieldPreEditorAction.REQUEST_PRE_EDITOR_DATA, FieldPreEditorSagaMethods.GetPreEditorData);
  yield takeLatest(
    actions.StartInterviewAction.SEND_PARTICIPANTS_LIST_ONSTART,
    StartInterviewMethods.StartInterviewParticipantsData
  );
  yield takeLatest(actions.StartInterviewAction.REQUEST_STARTINTERVIEW, StartInterviewMethods.StartInterviewData);
  yield takeLatest(actions.EndInterviewAction.REQUEST_ENDINTERVIEW, EndInterviewMethods.endInterview);
  yield takeLatest(actions.DeleteVideoNoteAction.REQUEST_DELETEVIDEONOTE, DeleteVideoNoteMethods.DeleteVideoNoteData);
  yield takeLatest(actions.DeleteVideoTagAction.REQUEST_DELETEVIDEOTAG, DeleteVideoTagMethods.DeleteVideoTagData);
  yield takeLatest(actions.EditVideoNoteAction.REQUEST_EDITVIDEONOTE, EditVideoNoteMethods.EditVideoNoteData);
  yield takeLatest(actions.EditButtonNameAction.REQUEST_EDITBUTTONNAME, EditButtonNameMethods.EditButtonNameData);
  yield takeLatest(actions.GetProfileAction.REQUEST_GETPROFILEDATA, GetProfileMethods.GetProfileData);
  yield takeLatest(actions.EditProfileAction.REQUEST_EDITPROFILEDATA, EditProfileMethods.EditProfileData);
  yield takeEvery(actions.analysisAction.REQUEST_ANALYSIS_DATA, analysisMethods.analysisData);
  yield takeEvery(actions.analysisAction.REQUEST_SCREENER_ANALYSIS_DATA, analysisMethods.analysisScreenerData);
  yield takeEvery(actions.analysisAction.REQUEST_ANALYSIS_CSV, analysisMethods.analysisCsv);
  yield takeEvery(actions.analysisAction.REQUEST_ANALYSIS_CSV_WITH_CODE, analysisMethods.analysisCsvWithCode);

  yield takeLatest(
    actions.PublishProjectAction.REQUEST_PUBLISH_PROJECT,
    GetPublishProjectMethods.GetPublishProjectData
  );
  yield takeLatest(actions.graphDataAction.REQUEST_GRAPH_DATA, graphMethods.graphData);
  yield takeLatest(actions.DeleteVideoClipAction.REQUEST_DELETEVIDEOCLIP, DeleteVideoClipMethods.DeleteVideoClipData);
  yield takeLatest(
    actions.ChangePasswordWebAction.REQUEST_CHANGEPASSWORDWEB,
    ChangePasswordWebMethods.ChangePasswordWebData
  );
  yield takeLatest(actions.analysisAction.REQUEST_WORD_ANSWER, wordMethods.wordData);
  yield takeLatest(actions.EditClipAction.REQUEST_EDITCLIP, EditClipMethods.EditClipData);
  yield takeLatest(actions.analysisAction.REQUEST_FILTER_DATA, filterMethods.filterData);
  yield takeLatest(actions.analysisAction.REQUEST_DELETE_CUSTOMTAG, filterMethods.deleteCustomtag);
  yield takeLatest(actions.analysisAction.REQUEST_CUSTOM_TAG_UPDATE, filterMethods.editCustomTagName);
  yield takeLatest(actions.analysisAction.REQUEST_ADD_COHORT, cohortMethods.cohortData);
  yield takeLatest(actions.analysisAction.REQUEST_DELETE_COHORT, cohortMethods.deleteCohort);
  yield takeLatest(VIDEO_USERLIST, VideoRecordingUserLists);
  yield takeLatest(REQUEST_GETUIDDETAILS, getUIDDetailss);
  yield takeLatest(actions.analysisAction.REQUEST_STICH_VIDEO, stitchVideo.stitchVideo);
  yield takeLatest(VIDEO_RECORDING_UPDATE, VideoRecordingUpdates);
  yield takeLatest(
    actions.AddReschduleSlotAction.REQUEST_RESCHEDULESLOT,
    AddRescheduleSlotMethods.AddRescheduleSlotData
  );
  yield takeLatest(actions.endProjectAction.REQUEST_ENDPROJECT, endProjectMethods.endProjectData);
  yield takeLatest(
    actions.AddRespondentAnswerAction.REQUEST_ADDRESPONDENTANSWER,
    AddRespondentAnswerMethods.AddRespondentAnswerData
  );
  yield takeLatest(RTC_TOKEN_BUILDER, RtcTokenBuilders);
  yield takeLatest(DELETE_TEAM_MEMBER, deleteTeamMember);
  yield takeLatest(
    actions.clientDashboardAction.REQUEST_CLIENTDASHBOARD_DATA,
    clientDashboardMethods.clientDashboardData
  );
  yield takeLatest(actions.EditTeamdataAction.REQUEST_EDITTEAMDATA, EditTeamMethods.EditTeamData);
  yield takeLatest(actions.AddNewUserAction.REQUEST_ADDNEWUSER, AddNewUserMethods.AddNewUserData);
  yield takeLatest(actions.EditUserdataAction.REQUEST_EDITUSERDATA, EditUserMethods.EditUserData);
  yield takeLatest(
    actions.AddNewClientAdminAction.REQUEST_ADDNEWCLIENT,
    AddNewClientAdminMethods.AddNewClientAdminData
  );
  yield takeLatest(
    actions.SuperAdminDashboardAction.REQUEST_SUPERADMINDASHBOARD_DATA,
    SuperAdminDashboardMethods.superAdminDashboardData
  );
  yield takeLatest(
    actions.EditClientAdminAction.REQUEST_EDITCLIENTADMINDATA,
    EditClientAdminMethods.EditClientAdminData
  );
  yield takeLatest(
    actions.ViewUserInGeneralPoolAction.REQUEST_USERINGENERALPOOL_DATA,
    viewUserInGeneralpoolMethods.viewUserInGeneralPoolData
  );
  yield takeLatest(
    actions.AddNewUserGenPoolAction.REQUEST_ADDNEWUSERGENPOOL,
    AddnewUserGenPoolMethods.AddNewUserGenPoolData
  );
  yield takeLatest(
    actions.EditResearcherDataGenPoolAction.REQUEST_EDITRESEARCHERDATAGENPOOL,
    EditResearcherGenPoolMethods.EditResearcherGenPoolData
  );
  yield takeLatest(
    actions.EditRespondantDataGenPoolAction.REQUEST_EDITRESPONDANTDATAGENPOOL,
    EditRespondantGenPoolMethods.EditRespondantGenPoolData
  );
  yield takeLatest(
    actions.ViewProjectSuperAdminDashboardAction.REQUEST_VIEWPROJECTSUPERADMINDASHBOARD_DATA,
    ViewProjectSuperAdminDashboardMethods.viewProjectSuperAdminData
  );
  yield takeLatest(actions.DeleteProjectAction.REQUEST_DELETEPROJECT, DeleteProjectMethods.DeleteProjectData);
  yield takeLatest(actions.otpAction.REQUEST_OTP, SendOtpMethods.Otp);
  yield takeLatest(actions.otpVerifyAction.REQUEST_VERIFY_OTP, OtpVerificationMethods.OtpVerificationData);
  yield takeLatest(actions.UpdatePasswordAction.REQUEST_UPDATE_PASSWORD, UpdatePasswordMethods.UpdatepasswordData);
  yield takeLatest(
    actions.ResetPasswordEmailNotificationAction.REQUEST_TOKEN_VALIDATE,
    PasswordResetEmailNotificatinValidateTokenMethods.PasswordEmailTokenValidate
  );

  yield takeLatest(actions.analysisAction.REQUEST_ANALYSIS_CLIPS_DATA, AnalysisClipsDataMethods.analysisClipsData);
  yield takeLatest(
    actions.analysisAction.REQUEST_ANALYSIS_CLIPS_WITHOUT_URL,
    AnalysisClipsDataMethods.analysisClipsWithoutUrl
  );
  yield takeLatest(actions.checkSummaryActions.REQUEST_CHECK_SUMMARY, checkSummaryMethods.checkSummary);
  yield takeLatest(actions.GetSummaryDataAction.REQUEST_SUMMARYDATA, getSummaryMethods.GetSummaryData);
  yield takeLatest(actions.GetSummaryDataAction.EDIT_SUMMARYDATA, getSummaryMethods.EditSummaryData);
  yield takeLatest(
    actions.generateSummaryActions.REQUEST_GENERATE_SUMMARY_DATA,
    generateSummaryMethods.generateSummary
  );
  yield takeLatest(actions.generateSummaryActions.REQUEST_AI_LOGS, generateSummaryMethods.storeAISummaryLogs);
  yield takeLatest(actions.StartInterviewAction.REQUEST_UPDATELAYOUT, updateLayoutMethods.UpdateLayoutData);
  yield takeLatest(actions.TranscriptCsvData.DOWNLOAD_TRANSCRIPT_DATA, downloadTranscriptMethods.transcriptCsvData);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
